import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import Loadable from 'components/Loadable';
import { lazyImportRetry } from 'utils/lazyRetry';
import DashboardLayout from 'layout/Dashboard';
import RouteErrorBoundary from 'routes/RouteErrorBoundary';
import { AdminRoute, ProtectedRoute } from 'components/auth/AuthGuards';
import SalifertTrendsPage from 'pages/reef/salifert-trends';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => lazyImportRetry(() => import('pages/dashboard/default'))));
const ReefDashboard = Loadable(lazy(() => lazyImportRetry(() => import('pages/reef/reef-dashboard'))));
const SalifertTests = Loadable(lazy(() => lazyImportRetry(() => import('pages/reef/salifert-tests'))));
const DosingPage = Loadable(lazy(() => lazyImportRetry(() => import('pages/reef/dosing'))));
const AlkalinityTest = Loadable(lazy(() => lazyImportRetry(() => import('pages/reef/alkalinity-test'))));
const JournalPage = Loadable(lazy(() => lazyImportRetry(() => import('pages/reef/journal'))));
const TanksPage = Loadable(lazy(() => lazyImportRetry(() => import('pages/reef/tanks'))));
const DevicesPage = Loadable(lazy(() => lazyImportRetry(() => import('pages/devices'))));
const UserSettings = Loadable(lazy(() => lazyImportRetry(() => import('pages/account/settings'))));
const PrivacyPolicyPage = Loadable(lazy(() => lazyImportRetry(() => import('pages/legal/PrivacyPolicyPage'))));
const AdminUsers = Loadable(lazy(() => lazyImportRetry(() => import('pages/admin/users'))));
const GetSubscription = Loadable(lazy(() => lazyImportRetry(() => import('pages/subscription/get-subscription'))));
const Unauthorized = Loadable(lazy(() => lazyImportRetry(() => import('pages/status/Unauthorized'))));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <ProtectedRoute>
      <DashboardLayout />
    </ProtectedRoute>
  ),
  errorElement: <RouteErrorBoundary />,
  children: [
    {
      index: true,
      element: <Navigate to="/reef-dashboard" replace />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: (
            <AdminRoute>
              <DashboardDefault />
            </AdminRoute>
          )
        }
      ]
    },
    {
      path: 'reef-dashboard',
      element: <ReefDashboard />
    },
    {
      path: 'salifert-tests',
      element: <SalifertTests />
    },
    {
      path: 'trends',
      element: <SalifertTrendsPage />
    },
    {
      path: 'dosing',
      element: <DosingPage />
    },
    {
      path: 'journal',
      element: <JournalPage />
    },
    {
      path: 'alkalinity-test',
      element: <AlkalinityTest />
    },
    {
      path: 'settings',
      element: <UserSettings />
    },
    {
      path: 'privacy-policy',
      element: <PrivacyPolicyPage />
    },
    {
      path: 'tanks',
      element: <TanksPage />
    },
    {
      path: 'devices',
      element: <DevicesPage />
    },
    {
      path: 'admin/users',
      element: (
        <AdminRoute>
          <AdminUsers />
        </AdminRoute>
      )
    },
    {
      path: 'get-subscription',
      element: <GetSubscription />
    },
    {
      path: 'unauthorized',
      element: <Unauthorized />
    }
  ]
};

export default MainRoutes;
